import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLine, Reveal } from "./Reveal";

export const DayForty = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const lineW = useTransform(scrollYProgress, [0.15, 0.6], ["0%", "100%"]);
  const glowO = useTransform(scrollYProgress, [0.2, 0.7], [0, 1]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-[#020202] px-5 py-36 sm:px-8 lg:py-56" data-testid="day-forty-section">
      <motion.div
        style={{ opacity: glowO }}
        className="pointer-events-none absolute left-1/2 top-1/2 h-[60vh] w-[80vw] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/[0.06] blur-3xl"
      />
      <div className="relative z-10 mx-auto max-w-6xl text-center">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.45em] text-gold" data-testid="day-forty-label">Giorno 40</p>
        </Reveal>

        <motion.div style={{ width: lineW }} className="mx-auto mt-10 h-px bg-gold/50" />

        <h2 className="mt-12 font-display font-bold uppercase leading-[1.02] tracking-tight" data-testid="day-forty-headline">
          <MaskedLine delay={0.1} className="text-5xl text-ivory sm:text-7xl lg:text-8xl">
            Il Deserto finisce.
          </MaskedLine>
          <MaskedLine delay={0.35} className="mt-2 text-5xl sm:text-7xl lg:text-8xl">
            <span className="text-transparent [-webkit-text-stroke:1.5px_#C5A059]">Il cammino no.</span>
          </MaskedLine>
        </h2>

        <Reveal delay={0.4} className="mx-auto mt-14 max-w-2xl">
          <p className="text-base leading-relaxed text-ivory/60 sm:text-lg">
            La Sfida del Deserto è stata creata per farti iniziare.
          </p>
          <p className="mt-2 font-display text-xl font-bold uppercase tracking-wide text-ivory sm:text-2xl">
            Tempio Vivo è stato creato per permetterti di <span className="text-gold">continuare</span>.
          </p>
        </Reveal>

        <Reveal delay={0.5} className="mx-auto mt-16 flex max-w-md items-center justify-center gap-4 text-[10px] uppercase tracking-[0.3em] text-ivory/40">
          <span>Deserto</span>
          <motion.span style={{ width: lineW }} className="h-px max-w-24 flex-1 bg-gold/60" />
          <span className="text-gold">Tempio Vivo</span>
        </Reveal>
      </div>
    </section>
  );
};
